import { useState } from "react";
import styles from "./KakaoChannelBanner.module.scss";
import axiosClient from "../../libs/axiosClient";
import kakaoChannelAdd from "../../assets/kakaoChannelAdd.png";

const KAKAO_JS_KEY = "2edf598182d9983a84c88b42b64e3f60";
const KAKAO_CHANNEL_PUBLIC_ID = "_xaxbskb";
// 카카오톡 채널 추가 이벤트 쿠폰셋 UID (ondoc-api .env의 KAKAO_CHANNEL_COUPON_SET_UID와 동일 값)
export const KAKAO_CHANNEL_COUPON_SET_ID = 22;

interface IPropsType {
  onCouponIssued: (couponId: string) => void;
}

function KakaoChannelBanner(props: IPropsType) {
  const [issuing, setIssuing] = useState(false);
  const [done, setDone] = useState(false);

  function handleClick() {
    const Kakao = (window as any).Kakao;
    if (!Kakao || issuing || done) return;
    if (!Kakao.isInitialized()) Kakao.init(KAKAO_JS_KEY);
    Kakao.Channel.followChannel({ channelPublicId: KAKAO_CHANNEL_PUBLIC_ID })
      // 채널 추가를 완료한 경우(success)에만 쿠폰 발급.
      // fail은 이미 추가된 상태 등 추가가 이뤄지지 않은 케이스,
      // 사용자가 창만 닫으면 Promise가 pending으로 남아 아무 일도 일어나지 않음
      .then((res: any) => {
        if (res?.status !== "success") {
          alert("이미 추가된 채널이거나 채널 추가가 완료되지 않았어요.");
          return;
        }
        setIssuing(true);
        axiosClient
          .post("/func/coupon/kakao-channel")
          .then((res) => {
            setDone(true);
            props.onCouponIssued(res.data.data.coupon_id);
          })
          .catch(() => {
            alert("쿠폰 발급에 실패했습니다. 잠시 후 다시 시도해주세요.");
          })
          .finally(() => setIssuing(false));
      });
  }

  return (
    <div className={styles.container} onClick={handleClick}>
      <div className={styles.textWrap}>
        {done ? (
          <strong>3,000원 할인 쿠폰이 발급되었습니다!</strong>
        ) : (
          <>
            <strong>카카오톡 채널 추가하고 3,000원 즉시할인</strong>
            <span>채널을 추가하면 바로 적용됩니다</span>
          </>
        )}
      </div>
      {!done && (
        <img
          className={styles.addButton}
          src={kakaoChannelAdd}
          alt="카카오톡 채널 추가 버튼"
        />
      )}
    </div>
  );
}
export default KakaoChannelBanner;
